import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./picklist.html";
class Picklist extends LightningElement {
  constructor() {
    super();
    this.value = [];
    this.name = '';
    this.inputOptions = void 0;
    this.hasRendered = void 0;
    this.picklistIsRendered = void 0;
    this.dropDownInFocus = false;
    this.inputValue = 'Select';
    this.allOptions = [];
    this.selectedTypes = [];
    this.selectedValues = [];
    this.handleClick = () => {
      let sldsCombobox = this.template.querySelector(".slds-combobox");
      sldsCombobox.classList.toggle("slds-is-open");
      let optionValues = [];
      if (!this.picklistIsRendered) {
        this.picklistIsRendered = true;
      }
      this.allOptions = this.getFormatOptions(this.allOptions);
      this.selectedValues = this.selectedValues !== '' && this.selectedValues.length > 0 ? this.getFormattedValues(this.selectedValues) : [];
      if (this.selectedValues && this.selectedValues.length > 0) {
        optionValues = this.allOptions.map(item => {
          return this.processItem(item, this.selectedValues);
        });
        this.value = optionValues.filter(item => item !== undefined);
      }
    };
    this.getFormatOptions = options => {
      let formattedOptions = [];
      if (options.length > 0) {
        for (let index = 0; index < options.length; index++) {
          formattedOptions.push(this.getFormatOption(options[index]));
        }
      }
      return formattedOptions;
    };
    this.getFormatOption = option => {
      if (option !== undefined) {
        return option.label;
      }
    };
    this.getFormattedValues = values => {
      let formattedValues = [];
      for (let index = 0; index < values.length; index++) {
        formattedValues.push(values[index]);
      }
      return formattedValues;
    };
    this.handleSelection = event => {
      let value = event.currentTarget.dataset.value;
      this.handleOption(event, value);
      const input = this.template.querySelector("input");
      input.focus();
      this.sendValues();
      const selectedTypeEvent = new CustomEvent('enablefiltericonontypesel', {
        detail: this.selectedTypes
      });
      this.dispatchEvent(selectedTypeEvent);
    };
    this.sendValues = () => {
      let values = [];
      for (const valueObject of this.value) {
        values.push({
          label: valueObject.label,
          name: valueObject.label
        });
      }
      this.selectedTypes = values;
      this.dispatchEvent(new CustomEvent("valuechange", {
        detail: values
      }));
    };
    this.handleOption = (event, value) => {
      let listBoxOption = event.currentTarget.firstChild;
      const tempArray = [];
      if (listBoxOption.classList.contains("slds-is-selected")) {
        if (this.selectedValues && this.selectedValues.length > 0) {
          let selValues = this.selectedValues;
          const selValueIndex = selValues.findIndex(option => option === value);
          selValues.splice(selValueIndex, 1);
          for (let index = 0; index < selValues.length; index++) {
            tempArray.push({
              label: selValues[index],
              value: selValues[index]
            });
          }
          this.value = tempArray.filter(option => option.label !== value);
        } else {
          this.value = this.value.filter(option => option.label !== value);
        }
      } else {
        let option = this.options.find(option => option.label === value);
        if (Object.keys(this.selectedValues).length === 0) {
          this.selectedValues = [];
        }
        if (option && Object.values(option).length > 0) {
          let optionValues = Object.values(option);
          this.value.push({
            label: optionValues[0],
            name: optionValues[1]
          });
          this.selectedValues.push(optionValues[0]);
        } else {
          this.value.push(option);
          this.selectedValues.push(option);
        }
      }
      if (this.value.length > 1) {
        this.inputValue = this.value.length + ' options selected';
      } else if (this.value.length === 1) {
        this.inputValue = this.value[0].label;
      } else if (this.value.length === 0) {
        this.inputValue = 'Select';
        const updatePicklistValEvent = new CustomEvent('updatedpicklistvalue', {
          detail: []
        });
        this.dispatchEvent(updatePicklistValEvent);
      }
      listBoxOption.classList.toggle("slds-is-selected");
    };
    this.handleBlur = () => {
      if (!this.dropDownInFocus) {
        this.closeDropbox();
      }
    };
    this.handleMouseleave = () => {
      this.dropDownInFocus = false;
      if (!this.dropDownInFocus) {
        this.closeDropbox();
      }
    };
    this.handleMouseEnter = () => {
      this.dropDownInFocus = true;
    };
    this.retainTypeSelection = (options, value, selValue) => {
      this.allOptions = options;
      this.inputValue = value;
      if (value !== 'Select') {
        if (selValue && selValue.length > 1) {
          this.value = options.filter(o1 => selValue.some(o2 => o1 === o2));
          if (this.value.length > 1) {
            this.inputValue = this.value.length + ' options selected';
          }
        } else if (selValue && selValue.length === 1) {
          this.inputValue = value;
        }
      }
      this.selectedValues = value;
      return this.inputValue;
    };
    this.getSelectedValues = () => {
      return this.selectedValues;
    };
    this.formatItem = item => {
      let formattedItem = '';
      for (let index = 0; index < item.length; index++) {
        if (/[^A-Za-z 0-9 _ -]/g.test(item[index])) {
          formattedItem += `\\${item[index]}`;
        } else {
          formattedItem += item[index];
        }
      }
      return formattedItem;
    };
    this.closeDropbox = () => {
      let sldsCombobox = this.template.querySelector(".slds-combobox");
      sldsCombobox.classList.remove("slds-is-open");
    };
    this.clearOptions = (allOptions, selValues) => {
      this.inputValue = 'Select';
      selValues = [...new Set(selValues)];
      allOptions = this.getFormatOptions(allOptions);
      let values = selValues.map(item => item.label);
      values = [...new Set(values)];
      allOptions.map(item => {
        return this.deselectTypeOptions(item, values);
      });
    };
    this.deselectTypeOptions = (item, value) => {
      if (value && value.includes(item)) {
        let tempItem = this.formatItem(item);
        const dataId = `div[data-my-id=${tempItem.split(/\s/).join('')}]`;
        if (this.template.querySelector(dataId)) {
          this.template.querySelector(dataId).classList.remove("slds-is-selected");
        }
        this.value = [];
        this.selectedValues = [];
      }
    };
  }
  get options() {
    return this.inputOptions.filter(option => option.value);
  }
  set options(value) {
    this.inputOptions = value;
  }
  processItem(item, selectedValues) {
    if (selectedValues && selectedValues.includes(item)) {
      let tempItem = this.formatItem(item);
      try {
        const dataId = `div[data-my-id=${tempItem.split(/\s/).join('')}]`;
        if (this.template.querySelector(dataId)) {
          this.template.querySelector(dataId).classList.add("slds-is-selected");
        }
      } catch (err) {
        console.log(err);
      }
      return {
        label: item,
        name: tempItem.split(/\s/).join('')
      };
    }
  }
}
_registerDecorators(Picklist, {
  publicProps: {
    value: {
      config: 0
    },
    name: {
      config: 0
    },
    inputValue: {
      config: 0
    },
    allOptions: {
      config: 0
    },
    selectedValues: {
      config: 0
    },
    options: {
      config: 3
    },
    retainTypeSelection: {
      config: 0
    },
    getSelectedValues: {
      config: 0
    },
    clearOptions: {
      config: 0
    }
  },
  fields: ["inputOptions", "hasRendered", "picklistIsRendered", "dropDownInFocus", "selectedTypes", "handleClick", "getFormatOptions", "getFormatOption", "getFormattedValues", "handleSelection", "sendValues", "handleOption", "handleBlur", "handleMouseleave", "handleMouseEnter", "formatItem", "closeDropbox", "deselectTypeOptions"]
});
export default _registerComponent(Picklist, {
  tmpl: _tmpl
});